import { z } from "zod";

export const transferEventSchema = z.object({
  eventId: z.string().min(1, "Veuillez sélectionner un événement"),
  connectId: z.string().length(10, "Veuillez entrer un Id Connect’Events"),
});

export const transferEventDefaultValues = {
  eventId: "",
  connectId: "",
};

export type TransferEventForm = z.infer<typeof transferEventSchema>;
